module.exports = __webpack_public_path__ + "img/ico2.9e5bd685.png";